import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Structură livrare',
  subtitle: 'Alegeți modul de livrare a comenzilor (per locație).',
  form: {
    delivery_mode: {
      label: 'Mod de livrare',
      placeholder: 'Selectați modul de livrare',
      options: {
        [DeliveryMode.Internal]: 'Intern (șoferi proprii)',
        [DeliveryMode.External]: 'Extern (terță parte)',
      },
    },
  },
  buttons: {
    back: 'Înapoi',
    next: 'Înainte',
    skip: 'Omite',
  },
  toasts: {
    error: 'Ceva nu a mers bine. Vă rugăm încercați din nou.',
  },
};
